import { useQuery } from 'react-query'
import Logger from '../../logging/logger'
import { getSettledPaymentsCount } from './settledPaymentsApi'

export const useSettledPaymentsCountQuery = (enabled: boolean) => {
  return useQuery(['settled-payments-count'], {
    queryFn: getSettledPaymentsCount,
    enabled,
    refetchOnWindowFocus: false,
    staleTime: Infinity,
    onError: () => {
      Logger.logWarning('Failed to fetch the settled payments count for survey targeting')
    }
  })
}
